module.exports = __webpack_public_path__ + "img/5-8.0a7a7bd2.jpg";